import React from 'react'
import '../css/site.css';

export default function OrderList() {
    //need to change this to take in an array for the custom orders and status like a state machine
    return (
        <div className="card-row no-wrap">
            <div className="purple-card">
                <h3>Currently Working On</h3>
                <p>
                    <h4>Commissions</h4>
                    <p>
                        1. Open!
                    </p>
                    <h4>Personal Projects</h4>
                    <p>
                        Stark & Fern Cosplays <br />
                    </p>
                    <img height="210px" src="images/ducktayto.png" alt="ducktayto personal growth" />
                </p>
                <br></br>
            </div>
             <div className="card">
                <h3>Crochet Spotlight</h3>
                <img className="card-img" src="images/gallery/freya_dress.jpg" alt="green yellow checkered dress" />
                <p>Freya Dress<br></br>
                    6/01/25</p>
            </div>
            <div className="card">
                <h3>Recent Make</h3>
                <img className="card-img" src="images/gallery/brushbuddies.jpg" alt="Brush Buddies from Witch Hat" />
                <p>Brush Buddies<br></br>
                    8/15/26</p>
            </div>
            <div className="card">
                <h3>Recent Make</h3>
                <img className="card-img" src="images/gallery/potato_psyduck.jpg" alt="fat psyduck" />
                <p>Ducktayto Psyduck<br></br>
                    4/23/26</p>
            </div>
        </div>
    );
}